import React, { useState, useEffect } from 'react';
import { fetchSettings } from '../utils/settingsApi';
import './AnnouncementModal.css';

export default function AnnouncementModal() {
    const [isVisible, setIsVisible] = useState(false);
    const [announcement, setAnnouncement] = useState(null);

    useEffect(() => {
        const loadAnnouncement = async () => {
            try {
                const settings = await fetchSettings();
                if (settings && settings.announcement_active === 'true') {
                    const dismissedId = localStorage.getItem('dismissed_announcement_id');
                    const currentId = settings.announcement_id;

                    if (currentId && dismissedId !== currentId) {
                        setAnnouncement({
                            title: settings.announcement_title || '',
                            text: settings.announcement_text || '',
                            image: settings.announcement_image_url || '',
                            id: currentId
                        });
                        setIsVisible(true);
                    }
                }
            } catch (error) {
                console.error("Error loading announcement:", error);
            }
        };
        
        // Add a small delay to make the popup feel natural
        setTimeout(() => {
            loadAnnouncement();
        }, 500);
    }, []);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                setIsVisible(false);
            }
        };
        if (isVisible) {
            window.addEventListener('keydown', handleKeyDown);
        }
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isVisible]);

    const handleClose = () => {
        setIsVisible(false);
    };

    const handleBackdropClick = (e) => {
        if (e.target.className === 'announcement-modal-backdrop') {
            setIsVisible(false);
        }
    };

    const handleDontShowAgain = () => {
        if (announcement && announcement.id) {
            localStorage.setItem('dismissed_announcement_id', announcement.id);
        }
        setIsVisible(false);
    };

    if (!isVisible || !announcement) return null;

    return (
        <div className="announcement-modal-backdrop" onClick={handleBackdropClick}>
            <div className="announcement-modal-content">
                <button className="announcement-modal-close" onClick={handleClose}>
                    &times;
                </button>
                {announcement.image && (
                    <div className="announcement-image-container">
                        <img src={announcement.image} alt="Announcement" className="announcement-image" />
                    </div>
                )}
                <div className="announcement-text-container">
                    {announcement.title && <h3 className="announcement-title">{announcement.title}</h3>}
                    {announcement.text && <p className="announcement-text">{announcement.text}</p>}
                </div>
                <div className="announcement-modal-actions">
                    <button className="btn btn-secondary dont-show-btn" onClick={handleDontShowAgain}>
                        Don't show this Next
                    </button>
                </div>
            </div>
        </div>
    );
}
